(() => {
  const PLACEHOLDER = 'サイズ・種類などを選択してください';

  const qs = (el, sel) => el ? el.querySelector(sel) : null;

  const setOpen = (fs, open) => {
    const head = qs(fs, '[data-va-head]');
    const panel = qs(fs, '[data-va-panel]');
    const inner = qs(fs, '[data-va-inner]');
    if (!head || !panel || !inner) return;

    if (open) {
      fs.classList.add('is-open');
      head.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      // 次フレームで高さ確定（Safari/差し替え直後に強い）
      requestAnimationFrame(() => {
        inner.style.maxHeight = inner.scrollHeight + 'px';
      });
    } else {
      fs.classList.remove('is-open');
      head.setAttribute('aria-expanded', 'false');
      inner.style.maxHeight = '0px';
      setTimeout(() => {
        if (!fs.classList.contains('is-open')) panel.hidden = true;
      }, 280);
    }
  };

  const syncSelectedUI = (fs, value) => {
    const headText = qs(fs, '[data-va-headtext]');
    const current = qs(fs, '[data-va-current]');
    if (headText) headText.textContent = value || PLACEHOLDER;
    if (current) current.textContent = value || '';

    fs.querySelectorAll('[data-va-for]').forEach(btn => {
      const v = btn.getAttribute('data-va-value') || '';
      btn.setAttribute('aria-selected', v === value ? 'true' : 'false');
    });
  };

  // --- クリックは全部ここで拾う（DOM差し替えに最強） ---
  document.addEventListener('click', (e) => {
    const headBtn = e.target.closest?.('[data-va-head]');
    if (headBtn) {
      const fs = headBtn.closest?.('[data-va-accordion]');
      if (!fs) return;

      // クリックが拾えてないケース対策：既定動作を止める
      e.preventDefault();
      e.stopPropagation();

      setOpen(fs, !fs.classList.contains('is-open'));
      return;
    }

    const optBtn = e.target.closest?.('[data-va-for]');
    if (optBtn) {
      const fs = optBtn.closest?.('[data-va-accordion]');
      if (!fs) return;

      e.preventDefault();
      e.stopPropagation();

      if (optBtn.disabled || optBtn.classList.contains('is-disabled')) return;

      const radioId = optBtn.getAttribute('data-va-for');
      const radio = fs.querySelector('#' + CSS.escape(radioId));
      if (!radio) return;

      const v = optBtn.getAttribute('data-va-value') || '';
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true })); // ←Riseに伝える

      syncSelectedUI(fs, v);
      setOpen(fs, false);
      return;
    }
  }, true); // ★captureで先に拾う（他JSに潰されない）

  // 変更が入ったら「表示」だけ追従（Riseが差し替えてもOK）
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t) return;

    if (t.classList?.contains('va__radio')) {
      const fs = t.closest?.('[data-va-accordion]');
      if (!fs) return;
      if (!t.checked) return;
      syncSelectedUI(fs, t.value);
      // 開いているなら高さ更新
      if (fs.classList.contains('is-open')) {
        const inner = qs(fs, '[data-va-inner]');
        if (inner) inner.style.maxHeight = inner.scrollHeight + 'px';
      }
    }
  }, true);

  // 初期表示合わせ（ページ読み込み直後）
  const initInitial = () => {
    document.querySelectorAll('[data-va-accordion]').forEach(fs => {
      const checked = fs.querySelector('.va__radio:checked');
      if (checked) syncSelectedUI(fs, checked.value);
      else {
        const headText = qs(fs, '[data-va-headtext]');
        if (headText) headText.textContent = PLACEHOLDER;
      }
      // 念のため閉じ状態を正規化
      setOpen(fs, false);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInitial);
  } else {
    initInitial();
  }

  document.addEventListener('shopify:section:load', () => {
    setTimeout(initInitial, 0);
  });
})();